export function billingCadence(plan: {interval: string; intervalCount: number}): string {
  return plan.intervalCount === 1 ? plan.interval : `${plan.intervalCount} ${plan.interval}s`;
}

export function billingMoney(minor:number,currency:string):string {
  return new Intl.NumberFormat(undefined,{style:'currency',currency:currency.toUpperCase()}).format(minor/100);
}
